<div class="col-md-12" style="display: flex; justify-content: flex-start; align-items: flex-start;">
    <div class="col-md-11 body-class">
        <h3> Paramétrage des catégories d’achat par destination </h3>
    </div>
    <div class="col-md-1 body-class" style="padding-top: 15px;">
      <button class="pull-right" color="warn" mat-raised-button type="button" (click)="onLeave()">
        <mat-icon>cancel</mat-icon> Fermer
      </button>
    </div>
  </div>
  <div class="col-md-12" style="display: flex; justify-content: flex-start; align-items: flex-start;">
    <div class="col-md-9">
        <app-autocomplete-with-code [(objet)]="activite" name="activite" (objetChange)="onChange($event)"
        libelle="Activité" [objets]="this.activites" [required]="true"  [forbiddenNames]="true">
      </app-autocomplete-with-code>
    </div>
    <div class="col-md-1 top">
      <button mat-raised-button color="success" (click)="enregistrer()">Enregistrer</button>
    </div>
  </div>  
  <div class="col-md-12">
    <div class="mat-table">
      <div class="table_principale">
        <table mat-table matSort [dataSource]="matDataSource" multiTemplateDataRows class="mat-elevation-z8" (matSortChange)="sortData($event)" matSortActive="categorie">
          <caption>Liste des destinations</caption>
          <ng-container matColumnDef="categorie">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Catégorie </th>
            <td mat-cell *matCellDef="let element"> 
              <div *ngIf="element.categorie">
                {{element.categorie.code}}: {{element.categorie.libelle}} 
              </div>
            </td>
          </ng-container>
      
          <ng-container matColumnDef="destination1">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Commerce </th>
            <td mat-cell *matCellDef="let element" > 
              <div class="center col-md-10">
                <app-autocomplete-with-code [(objet)]="element.commerce" name="commerce"
                libelle="" [objets]="this.nas" [required]="false"  [forbiddenNames]="true">
                </app-autocomplete-with-code>
              </div> 
            </td>
          </ng-container>
  
          <ng-container matColumnDef="destination2">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Frais Généraux </th>
            <td mat-cell *matCellDef="let element" > 
              <div class="center col-md-10">
                <app-autocomplete-with-code [(objet)]="element.fraisGeneraux" name="commerce"
              libelle="" [objets]="this.nas" [required]="false"  [forbiddenNames]="true">
                </app-autocomplete-with-code>
              </div> 
            </td>
          </ng-container>
  
          <ng-container matColumnDef="destination3">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Exploitation </th>
            <td mat-cell *matCellDef="let element">
              <div class="center col-md-10">
                <app-autocomplete-with-code [(objet)]="element.exploitation" name="commerce"
                libelle="" [objets]="this.nas" [required]="false"  [forbiddenNames]="true">
                </app-autocomplete-with-code>
              </div> 
            </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns, sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></tr>
        </table>
      </div>
    </div>
  </div>
